export const CLIENT_DISPATCHER_MODULE = 'ClientDispatcher' as const;
